import { friendlyAlignmentStrength } from '@upright/common/model/input/sdg-alignment/friendly';
import { sdgAlignmentLevelToValence } from '@upright/common/model/output/scores/sdg-alignment/shared';
import { SdgAlignmentLevel, SdgId } from '@upright/common/model/output/scores/sdg-alignment/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { toSdgAlignmentStrength } from '@upright/ui/common/upright/core/impact-lenses/sdg/common/utils';
import {
  getSdgColor,
  getSdgTextColorOnColoredBackground,
} from '@upright/ui/common/upright/model/output/scores/sdg-alignments/shared';
import { color } from 'd3-color';
import styled from 'styled-components';

interface Props {
  sdgId: SdgId;
  level: SdgAlignmentLevel;
}

export function LevelBox(props: Props) {
  const strength = toSdgAlignmentStrength(props.level);
  const backgroundColor = getSdgColor(sdgAlignmentLevelToValence(props.level), strength);
  const textColor = getSdgTextColorOnColoredBackground(sdgAlignmentLevelToValence(props.level), strength);

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const borderColor = color(backgroundColor)!.darker(0.5).formatHex();
  return <Root style={{ backgroundColor, color: textColor, borderColor }}>{friendlyAlignmentStrength(strength)}</Root>;
}

const Root = styled.div`
  background-color: ${BouColor.TOOL_BACKGROUND_LIGHT_PURPLE};
  border-radius: 4px;
  border: 1px solid black;
  padding-left: 0.4em;
  padding-right: 0.4em;
  padding-top: 0.2em;
  padding-bottom: 0.2em;
  font-weight: 500;
  margin-left: 0.5em;
`;
